<template>
  <el-dialog width='60%' :visible='true' :before-close='closeForm'>
    <div class='title_popup text-center'>
      <FAIcon icon='fas fa-eraser' />
      {{ mode === IgnoreUserFormMode.EDIT ? 'Chỉnh sửa thông tin loại trừ' : 'Loại bỏ kết quả kiểm tra' }}
    </div>

    <el-form ref='formPlagiarism' label-width='200px' label-position='right'>
      <el-form-item label='Loại lý do'>
        <el-select v-model='reasonIgnoreType' placeholder='Các loại lý do'>
          <el-option
            v-for='reason of ReasonIgnoreTypes'
            :key='reason.type'
            :label='reason.name'
            :value='reason.type'>
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label='Mô tả lý do'>
        <el-input
          type='textarea'
          :autosize='{ minRows: 2, maxRows: 4}'
          placeholder='Mô tả lý do loại trừ kết quả'
          v-model='reasonDescription'>
        </el-input>
      </el-form-item>
      <el-form-item label='Phần nội dung sao chép' v-if='mode === IgnoreUserFormMode.NEW'>
        <p v-html='similarContent'
           class='ignore-popup-content local-scroller scrollable'></p>
      </el-form-item>
    </el-form>
    <span slot='footer' class='dialog-footer'>
            <el-button @click='closeForm()'><FAIcon icon='fas fa-times' /> Hủy bỏ</el-button>
            <el-button type='primary' @click='onSubmitIgnoredByUserForm'><i
              class='fas fa-check'></i> Xác nhận</el-button>
        </span>
  </el-dialog>
</template>

<script>
import { IgnoreUserFormMode, ReasonIgnoreTypes, reloadGroupType } from '@/constants/DoITConstant'
import { AUTHENTICATE_STORE } from '@/store/modules/AuthenticateStore'
import { mapState } from 'vuex'

export default {
  name: 'IgnoreByUserForm',
  props: ['mode'],
  data: () => {
    return {
      ReasonIgnoreTypes,
      reasonIgnoreType: ReasonIgnoreTypes.system_detect_wrong,
      reasonDescription: '',
      IgnoreUserFormMode
    }
  },
  methods: {
    closeForm() {
      this.$emit('done')
    },
    onSubmitIgnoredByUserForm() {
      let userInfo = this.user
      let docInfo = this.$store.getters['docRes/documentInfoCurrent']
      console.log(docInfo)
      console.log('userInfo: ', userInfo)
      let isOwnerCreate = null
      if (userInfo.id === docInfo.ownerId) {
        isOwnerCreate = true
      } else {
        isOwnerCreate = false
      }
      const plagCurrentInfo = this.$store.getters['docRes/plagiarism/resultPlagCurrentPopup']
      let ignoredSentenceIds = plagCurrentInfo.parts.map(part => part.sentenceId)

      let resultPlagIgnored = {
        isIgnored: true,
        sentenceIds: ignoredSentenceIds,
        reason: this.reasonDescription,
        isOwnerCreate: isOwnerCreate,
        reasonIgnoreType: this.reasonIgnoreType,
        tsCreate: new Date().getTime(),
        userIdCreate: userInfo.id
      }

      // Updates array lstResultPlagIgnoredCurrent (data ignored by user)
      this.$store.dispatch('docRes/plagiarism/updateLstResultPlagIgnoredCurrent', {
        resultPlagIgnored: resultPlagIgnored,
        isUndo: false
      })

      // Hide popup "Ignored by user"
      this.$store.dispatch('docRes/plagiarism/updateIsShowPlagPopup', false)

      if (this.mode === IgnoreUserFormMode.NEW) {
        this.$emit('reload-group', { resultPlag: this.resultPlagCurrentPopup, type: reloadGroupType.IGNORE_SENTENCE })
      }
      // Hide Popup config ignored by user
      this.closeForm()
    }
  },
  computed: {
    resultPlagCurrentPopup() {
      console.log('current popup', this.$store.getters['docRes/plagiarism/resultPlagCurrentPopup'])
      return this.$store.getters['docRes/plagiarism/resultPlagCurrentPopup']
    },
    similarContent() {
      let content = ''
      if (!this.resultPlagCurrentPopup.isIgnored) {
        this.resultPlagCurrentPopup.parts.forEach(part => {
          const similarSentence = this.$store.getters['docRes/plagiarism/getSimilarSentence'](part.similarSentenceId)
          content += similarSentence.content
        })
      }
      return content
    },
    ...mapState({
      user: (state) => state[AUTHENTICATE_STORE].user,
    })
  },
  mounted() {
    let plagCurrentData = this.$store.getters['docRes/plagiarism/resultPlagCurrentPopup']
    // this.reasonDescription = plagCurrentData.ignoreByUserReason
    this.reasonIgnoreType = plagCurrentData.ignoredReason
  }
}
</script>

<style scoped>
.ignore-popup-content {
  max-height: 150px;
  min-height: 100px;
  border: 1px solid rgba(168, 168, 168, 0.32);
  border-radius: 5px;
  padding: 2px 10px 2px 10px;
}
</style>
